import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import disableBrowserBackButton from "disable-browser-back-navigation";

import FileItem from "./fileItem.js";
import { mandantActions, messageActions } from "../actions";
import RESPONSE_HEADER from "../utils/enums/RESPONSE_HEADER.js";

class FileList extends Component {
  constructor(pros) {
    super(pros);
    this.state = {
      deleteError: null,
      deleteSuccess: null,
      // detailItem: {},
      // chosenImg: ""
    };
    this.deleteFile = this.deleteFile.bind(this);
  }
  componentDidMount = async () => {
    disableBrowserBackButton();
  };

  async deleteFile(e, fileId) {
    e.preventDefault();
    this.setState({ deleteError: null, deleteSuccess: null });
    //get url of config.js
    let deleteFileRequestData = this.props.configStorage.getRequestData("deleteFile", "delete");
    deleteFileRequestData.url = deleteFileRequestData.url + fileId;
    const mandantRequestData = this.props.configStorage.getRequestData("mandant");
    if (this.props.gpNummer && this.props.configStorage.isBLBAdmin()) {
      mandantRequestData.url += this.props.gpNummer;
    }
    await axios.delete(deleteFileRequestData.url).then(res => {
      if (res && res.data && res.data.header && res.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
        this.setState({ deleteSuccess: "Die Datei wurde gelöscht" });
        this.props.dispatch(messageActions.fileMessage({ item: { fileId: -1 }, message: true, error: false }));
        return this.props.dispatch(mandantActions.fetchMandantData(mandantRequestData));
      } else {
        throw new Error("Die Datei konnte nicht gelöscht werden")
      }
    }).catch(e => {
      this.setState({ deleteError: e });
      this.props.dispatch(messageActions.fileMessage({ item: { fileId: -1 }, message: false, error: true }));
    });
  }

  render() {
    const files = this.props.mandantStorage.files;
    if (!files || !files.fileList || !files.fileList.length) return null;
    return (
      <div>
        {this.state.deleteError && this.props.messageStorage.displayFileError(-1)
          ? <div className="alert alert-danger alert-dismissible align-items-start fade show">
            <p>Beim Löschen ist ein Fehler aufgetreten:</p>
            {this.state.deleteError.message
              ? <p>{this.state.deleteError.message}</p>
              : null
            }
          </div>
          : null
        }
        {this.state.deleteSuccess && this.props.messageStorage.displayFileMessage(-1)
          ? <div className="alert alert-info alert-dismissible align-items-start fade show">
            {this.state.deleteSuccess}
          </div>
          : null
        }
        <table className="table">
          <tbody>
            {files.fileList.map((file) => {
              return <FileItem
                key={"file_" + file.fileId}
                item={file}
                loadMandant={this.props.loadMandant}
                deleteFile={this.deleteFile}
                displayDelete={true}
                buttonLabel="Ändern"
                disabled={this.props.disabled}
              />;
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(store => {
  return {
    mandantStorage: store.mandantStorage,
    configStorage: store.configStorage,
    messageStorage: store.messageStorage
  };
})(FileList);
